import React, { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import Box from '@material-ui/core/Box'
import Heading from 'ui/modules/heading'
import Typography from '@material-ui/core/Typography'
import NewSearch from './common/newSearch'
import Actions from './actions'
import SearchList from 'ui/modules/lists/searchList'
import EmptyStateManager from 'containers/EmptyStateManager'
import useTranslation from 'hooks/useTranslations'

const Search = props => {
  const {
    isLoading,
    children,
    totalElements,
    handleBulkSelect,
    selectedCount,
    handleAddVendor,
    searchConfig,
    clearSearchOptions,
    genericError,
    onSearch,
    onRemoveVendors,
  } = props

  const t = useTranslation()
  const history = useHistory()
  const resultsRef = React.useRef(null)

  const selectedStatus = useMemo(() => {
    if (selectedCount === 0) return 'none'
    if (selectedCount === totalElements) return 'full'
    return 'partial'
  }, [selectedCount, totalElements])

  useEffect(() => {
    if (history.location.hash && resultsRef) {
      resultsRef.current.scrollIntoView()
    }
  }, [history, resultsRef])

  return (
    <>
      <Box mb={3}>
        <Typography variant="h1">{t('home:new-search')}</Typography>
      </Box>
      <NewSearch
        searchConfig={searchConfig}
        clearSearchOptions={clearSearchOptions}
        genericError={genericError}
        onSearch={onSearch}
        onConfigChange={() => {}}
      />
      {/* TODO: @paco refactor */}
      <Box style={{ position: 'relative', top: -72 }} ref={resultsRef} />
      <Heading
        type="searches"
        title={t('home:saved-searches')}
        number={totalElements}
      />
      {!totalElements ? (
        <EmptyStateManager type={'noSearches'} />
      ) : (
        <Box display="flex" flexDirection="column">
          <SearchList height={468} isLoading={isLoading}>
            {children}
          </SearchList>
          <Actions
            status={selectedStatus}
            onBulkSelect={handleBulkSelect}
            canDelete={!selectedCount}
            onAddVendor={handleAddVendor}
            onRemoveVendors={onRemoveVendors}
          />
        </Box>
      )}
    </>
  )
}

Search.propTypes = {
  isLoading: PropTypes.bool,
  totalElements: PropTypes.number,
  handleBulkSelect: PropTypes.func,
  selectedCount: PropTypes.number,
  onRemoveVendors: PropTypes.func,
  totalSearches: PropTypes.number,
  searchConfig: PropTypes.object,
}

export default Search
